import { component } from 'picoapp';

import Swiper, { SwiperOptions, Navigation } from 'swiper';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

import Modal from '~/js/utils/modal';
import closeIcon from '~/js/lib/close-icon';

gsap.registerPlugin(ScrollTrigger);

export default component(() => {
  /**
   * Global DOM elems + vars
   */
  const modalMainMobileImages = document.querySelectorAll('[data-main-mobile-image]');
  const modalMainImages = document.querySelectorAll('[data-main-image]');
  const modalToggles = document.querySelectorAll('[data-modal-toggle]');
  const ww = window.innerWidth;

  /**
   * Functions
   */

  // Create modal
  const modalElem: HTMLElement = document.querySelector('[data-modal]');
  const modal = Modal(modalElem);

  // Create image slider
  const sliderElem: HTMLElement = document.querySelector('[data-lightbox-slider]');
  const swiperConfig: SwiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    init: false,
    spaceBetween: 0,
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
  };

  const modalSlider = new Swiper(sliderElem, swiperConfig);
  modalSlider.init();

  // Destroy zoomed image
  const removeZoomedElem = (elems: any) => {
    elems.forEach((element) => {
      element.addEventListener('click', () => {
        elems.forEach((elem) => {
          elem.classList.add('hidden');
          setTimeout(() => {
            elem.remove();
          }, 500);
        });
      });
    });
  };

  // Zoom image
  const zoomImageElems = document.querySelectorAll('[data-zoom-image]');
  const modalContainer = document.querySelector('[data-modal-container]');

  const zoomImage = (imgMarkup: any, imageWidth: number, imageHeight: number) => {
    // Create temporary div to insert image markup
    const temp = document.createElement('div');
    temp.innerHTML = imgMarkup;

    // Select the image
    const imageElem = temp.querySelector('img');
    // Get alle the srcsets from original image
    // to insert biggest possible image to avoid loss in image quality
    const imageSrcsetArray = imageElem.getAttribute('srcset').split(',');
    const lastSrcset = imageSrcsetArray[imageSrcsetArray.length - 1];

    // Create the new, zoomed-in image and add attributes
    const zoomedImage = document.createElement('img');
    zoomedImage.setAttribute('srcset', lastSrcset);
    zoomedImage.classList.add('cursor-zoomOut');

    // Create the zoomed-in div to wrap around image
    const zoomedDiv = document.createElement('div');

    zoomedDiv.setAttribute('data-zoomed-elem', 'open');
    zoomedDiv.appendChild(zoomedImage);

    if (ww < 641) {
      zoomedDiv.classList.add('product__zoom-container', 'flex', 'items-center', 'fixed', 'top-1/2', 'left-1/2', 'transform', '-translate-y-1/2', '-translate-x-1/2', 'w-full', 'h-full', 'bg-gray-200', 'z-100', 'overflow-scroll', 'transition-all', 'duration-500', 'ease-out');
    } else {
      zoomedDiv.classList.add('product__zoom-container', 'fixed', 'top-1/2', 'left-1/2', 'transform', '-translate-y-1/2', '-translate-x-1/2', 'bg-gray-200', 'z-100', 'overflow-scroll', 'transition-all', 'duration-500', 'ease-out');
      zoomedDiv.style.width = `${imageWidth}px`;
      zoomedDiv.style.height = `${imageHeight}px`;
    }

    const closeButton = document.createElement('button');
    closeButton.classList.add('fixed', 'top-20', 'right-10', 'z-101');
    closeButton.innerHTML = closeIcon();

    setTimeout(() => {
      modalContainer.appendChild(closeButton);
    }, 1000);

    modalContainer.appendChild(zoomedDiv);

    // eslint-disable-next-line max-len
    const diff = (zoomedImage.getBoundingClientRect().width - zoomedDiv.getBoundingClientRect().width) / 2;
    zoomedDiv.scrollTo({
      top: 0,
      left: diff,
      behavior: 'smooth',
    });

    if (ww > 640) {
      setTimeout(() => {
        zoomedDiv.style.width = '100%';
        zoomedDiv.style.height = '100vh';
      }, 500);
    }

    const arr = [zoomedDiv, closeButton];
    removeZoomedElem(arr);
  };

  // Image navigation
  const navItems = [...document.querySelectorAll('[data-lightbox-nav-item]')];
  const slideToImage = (index: number) => {
    navItems.forEach((navItem) => {
      navItem.classList.remove('border-black');
    });
    navItems[index].classList.add('border-black');
    modalSlider.slideTo(index);
  };

  /**
   * Eventlisteners
   */
  modalMainMobileImages.forEach((mainMobileImage, index) => {
    mainMobileImage.addEventListener('click', () => {
      slideToImage(index);
    });
  });

  modalMainImages.forEach((mainImage, index) => {
    mainImage.addEventListener('click', () => {
      slideToImage(index);
    });
  });

  modalToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      modal.toggle();
      document.body.classList.toggle('no--scroll');
    });
  });

  navItems.forEach((item: HTMLElement, index) => {
    item.addEventListener('click', () => {
      slideToImage(index);
    });
  });

  modalSlider.on('slideChange', ({ activeIndex }) => {
    slideToImage(activeIndex);
  });

  zoomImageElems.forEach((zoomElem: HTMLElement) => {
    zoomElem.addEventListener('click', () => {
      const imgMarkup = zoomElem.innerHTML;
      const imageWidth = zoomElem.getBoundingClientRect().width;
      const imageHeight = zoomElem.getBoundingClientRect().height;
      zoomImage(imgMarkup, imageWidth, imageHeight);
    });
  });
});
